import styled from 'styled-components'

export const Container = styled.div.attrs({
    className: 'form-edicao-instituicao'
})`
	display: grid;
	grid-template-columns: 1fr 1fr 1fr;
	grid-template-areas:
		'tips tips tips'
		'f1 f2 f3'
		'f4 f5 f6'
		'line_1 line_1 line_1'
		'titulo_endereco titulo_endereco titulo_endereco'
		'f7 f8 f9'
		'f10 f11 f12'
		'f13 x x'
		'line_2 line_2 line_2'
		'titulo_representante titulo_representante titulo_representante'
		'erro_representante erro_representante erro_representante'
		'representante representante y'
		'button button button';

	h2 {
		font-size: 16px;
		font-weight: 700;
		margin: 0 12px;
	}

	hr {	
		grid-area: line;
		margin: 12px 8px;
		width: calc(100% - 16px);
		border: solid #fff8 0.5px;
	}

	.button-container {
		grid-area: button;
		display: flex;
		justify-content: end;
	}

	@media(max-width: 700px) {
		display: flex;
		flex-direction: column;
	}
`
